import { render, staticRenderFns } from "./ChartDelivery.vue?vue&type=template&id=13af03d8&scoped=true&"
import script from "./ChartDelivery.vue?vue&type=script&lang=js&"
export * from "./ChartDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ChartDelivery.vue?vue&type=style&index=0&id=13af03d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af03d8",
  null
  
)

export default component.exports